<template>
  <div class='AdmTitle'>
    {{ text }}
  </div>
</template>

<script>
export default {
  name: 'AdmTitle',
  props: {
    text: {
      type: String,
      default: 'Adm Title'
    }
  }
}
</script>

<style scoped>
.AdmTitle {
  padding: 2%;
  text-align: left;
  font-size: 20px;
  font-weight: bold;
}
</style>
